import { createReducer, on } from '@ngrx/store';
import { IHelpDocumentsState } from './help-documents.state';
import {
  loadHelpDocuments,
  loadHelpDocumentsFailure,
  loadHelpDocumentsSuccess,
} from './help-documents.actions';

export const initialState: IHelpDocumentsState = {
  documents: [],
  loading: false,
  loaded: false,
  error: false,
};

export const helpDocumentsReducer = createReducer(
  initialState,
  on(loadHelpDocuments, (state) => ({
    ...state,
    loading: true,
    error: false,
  })),
  on(loadHelpDocumentsSuccess, (state, { documents }) => ({
    ...state,
    documents,
    loading: false,
    loaded: true,
  })),
  on(loadHelpDocumentsFailure, (state) => ({
    ...state,
    documents: [],
    loading: false,
    loaded: true,
    error: true,
  }))
);
